<template>
  <div class="wrapper" :class="{ mobile: !isLargeScreen }">
    <div class="firing-alerts" :class="{ warning: !!firingAlertsAmount }">
      <div class="title">
        <fa
          :icon="!!firingAlertsAmount ? 'exclamation-triangle' : 'check-circle'"
        ></fa>
        <h5 v-if="!isMobile">
          {{
            !!firingAlertsAmount ? 'You have firing alerts' : 'No firing alerts'
          }}
        </h5>
        <h5 v-else>
          {{ !!firingAlertsAmount ? 'Firing alerts' : 'No firing alerts' }}
        </h5>
      </div>
      <p v-if="!!firingAlertsAmount" class="number">{{ firingAlertsAmount }}</p>
    </div>
    <div class="last-firing-alert">
      <div class="title">
        <h5>
          Last firing alert
        </h5>
        <span>(last 7 days)</span>
      </div>
      <div v-if="!lastFiringAlert || !lastFiringAlert.name">
        No firing alert in the last 7 days.
      </div>
      <div v-else>
        <div class="description-wrapper">
          <h6>Alert name:</h6>
          <span class="truncated">{{ lastFiringAlert.name }}</span>
        </div>
        <div class="description-wrapper">
          <h6>Timestamp:</h6>
          <span>{{ lastFiringAlert.datetime | timestampFormatter }}</span>
        </div>
        <div class="description-wrapper">
          <h6>Trigger:</h6>
          <span>
            {{ trigger }}
            <span
              v-if="isTriggerListSliced"
              class="show-more"
              @click="
                setShowMoreModalObj({
                  isShown: true,
                  bodyTextOfTriggers: allAlertTriggers,
                  bodyTextOfIncident: lastFiringAlert.reason,
                  modalType: SHOW_MORE_MODAL_TYPE.TRIGGERS,
                  alertId: lastFiringAlert.id
                })
              "
              >and {{ slicedTriggerAmount }} more</span
            >
          </span>
        </div>
        <div class="description-wrapper">
          <h6>Incident:</h6>
          <span>
            {{ reason }}
            <span
              v-if="isReasonSliced"
              class="show-more"
              @click="
                setShowMoreModalObj({
                  isShown: true,
                  bodyTextOfTriggers: allAlertTriggers,
                  bodyTextOfIncident: lastFiringAlert.reason,
                  modalType: SHOW_MORE_MODAL_TYPE.INCIDENT,
                  alertId: lastFiringAlert.id
                })
              "
              >...and more</span
            >
          </span>
        </div>
        <div class="expand-alert">
          <span @click="expandAlert(lastFiringAlert.id)">
            More details
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import {
  MAX_TRIGGERS_SHOWN,
  MAX_INCIDENT_CHARACTERS_SHOWN,
  SHOW_MORE_MODAL_TYPE
} from '../../../../constants/alertsRoutingStatusConstant';

export default {
  name: 'FiringAlertsRSCard',
  props: {
    firingAlertsAmount: {
      type: Number,
      required: true
    },
    lastFiringAlert: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      allAlertTriggers: '',
      slicedTriggerAmount: 0,
      isReasonSliced: false,
      SHOW_MORE_MODAL_TYPE: SHOW_MORE_MODAL_TYPE
    };
  },
  computed: {
    ...mapGetters(['isLargeScreen', 'isMobile']),
    ...mapState('alertsRoutingStatusStore', ['searchQuery']),
    trigger() {
      if (
        this.lastFiringAlert.triggerPrefixes &&
        this.lastFiringAlert.triggerPrefixes.length &&
        this.lastFiringAlert.triggerPrefixes.length <= MAX_TRIGGERS_SHOWN
      ) {
        return this.lastFiringAlert.triggerPrefixes.join(', ');
      } else if (
        this.lastFiringAlert.triggerPrefixes &&
        this.lastFiringAlert.triggerPrefixes.length > MAX_TRIGGERS_SHOWN
      ) {
        this.allAlertTriggers = this.lastFiringAlert.triggerPrefixes.join(', ');

        return this.lastFiringAlert.triggerPrefixes
          .slice(0, MAX_TRIGGERS_SHOWN)
          .join(', ');
      } else if (
        this.lastFiringAlert.triggerOrigins &&
        this.lastFiringAlert.triggerOrigins.length &&
        this.lastFiringAlert.triggerOrigins.length <= MAX_TRIGGERS_SHOWN
      ) {
        return this.lastFiringAlert.triggerOrigins
          .map(item => `AS${item}`)
          .join(', ');
      } else if (
        this.lastFiringAlert.triggerOrigins &&
        this.lastFiringAlert.triggerOrigins.length > MAX_TRIGGERS_SHOWN
      ) {
        this.allAlertTriggers = this.lastFiringAlert.triggerOrigins
          .map(item => `AS${item}`)
          .join(', ');

        return this.lastFiringAlert.triggerOrigins
          .slice(0, MAX_TRIGGERS_SHOWN)
          .map(item => `AS${item}`)
          .join(', ');
      } else {
        return '-';
      }
    },
    isTriggerListSliced() {
      if (
        this.lastFiringAlert.triggerPrefixes &&
        this.lastFiringAlert.triggerPrefixes.length > MAX_TRIGGERS_SHOWN
      ) {
        this.slicedTriggerAmount =
          this.lastFiringAlert.triggerPrefixes.length - MAX_TRIGGERS_SHOWN;

        return true;
      } else if (
        this.lastFiringAlert.triggerOrigins &&
        this.lastFiringAlert.triggerOrigins.length > MAX_TRIGGERS_SHOWN
      ) {
        this.slicedTriggerAmount =
          this.lastFiringAlert.triggerOrigins.length - MAX_TRIGGERS_SHOWN;

        return true;
      } else {
        this.slicedTriggerAmount = 0;

        return false;
      }
    },
    reason() {
      if (
        this.lastFiringAlert.reason &&
        this.lastFiringAlert.reason.length > MAX_INCIDENT_CHARACTERS_SHOWN
      ) {
        this.isReasonSliced = true;

        let slicedReason = this.lastFiringAlert.reason.slice(
          0,
          MAX_INCIDENT_CHARACTERS_SHOWN
        );
        const lastIndexOfComma = slicedReason.lastIndexOf(',');
        slicedReason = slicedReason.slice(0, lastIndexOfComma);

        return slicedReason;
      } else {
        this.isReasonSliced = false;

        return this.lastFiringAlert.reason || '';
      }
    }
  },

  methods: {
    ...mapMutations('alertsRoutingStatusStore', [
      'setShowMoreModalObj',
      'setSearchQuery',
      'setExpandedAlertId'
    ]),

    expandAlert(alertId) {
      if (this.searchQuery) {
        // If searchQuery exists, clear it first. Otherwise the last firing alert may not in the filtered alert list.
        this.setSearchQuery('');

        // Use setTimeout to allow the filtered alert list to be refreshed. Otherwise the last firing alert may not in the filtered alert list.
        setTimeout(() => {
          this.setExpandedAlertId(alertId);
        }, 500);
      } else {
        this.setExpandedAlertId(alertId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 1.5rem;
  width: 100%;
  background-color: #ffffff;
}

.firing-alerts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid $border-grey;
  color: #208836;

  &.warning {
    color: $warning-red;
  }

  .title {
    h5 {
      display: inline-block;
      margin: 0;
      padding-left: 1rem;
      font-size: 1.125rem;
      color: inherit;
    }
    span {
      display: inline-block;
      font-size: 1rem;
      font-weight: 400;
      text-indent: 0.5rem;
    }
    svg {
      font-size: 1.25rem;
    }
  }

  .number {
    font-size: 2.5rem;
    margin: 0;
    color: inherit;
  }
}

.last-firing-alert {
  .title {
    h5 {
      font-size: 1.125rem;
      margin-bottom: 0.5rem;
      display: inline-block;
    }
    span {
      display: inline-block;
      font-size: 1rem;
      font-weight: 400;
      text-indent: 0.5rem;
    }
  }

  .description-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 0.75rem;

    h6 {
      margin-bottom: 0;
      margin-right: 0.5rem;
    }

    .show-more {
      color: $apnic-blue;
      cursor: pointer;
    }
  }

  .expand-alert {
    margin-top: 0.5rem;

    text-align: right;
    color: $text-light-blue;

    span {
      padding: 0 0.5rem;
      cursor: pointer;
    }
  }
}

.mobile {
  .wrapper {
    padding: 1.5rem;
  }

  .firing-alerts {
    align-items: center;
    padding-bottom: 1.5rem;

    .title {
      h5 {
        margin-bottom: 0;
      }

      span {
        display: inline-block;
      }
    }
  }

  .last-firing-alert {
    .title {
      h5 {
        margin-bottom: 0.5rem;
      }

      span {
        display: inline-block;
      }
    }
  }

  p {
    margin-bottom: 0;
  }

  .number {
    margin-right: 0.5rem;
  }
}
</style>
